
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/financials/other-items-category/list",
      function () {
        return require("private-next-pages/admin/financials/other-items-category/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/financials/other-items-category/list"])
      });
    }
  